import Script from 'next/script';

import { isReactSnap } from '../../utils/env';

type AnalyticsScriptProps = {
  recaptchaSiteKey?: string;
};

export default function AnalyticsScript({ recaptchaSiteKey }: AnalyticsScriptProps) {
  const gtmScript = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PQ45W6W');
  `;

  if (isReactSnap()) {
    return null;
  }

  return (
    <>
      <Script
        id="gtm-picsart.com"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: gtmScript,
        }}
      />

      {recaptchaSiteKey ? (
        <Script
          async
          strategy="afterInteractive"
          src={`https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`}
        />
      ) : null}
    </>
  );
}
